<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row m-0">
                <div class=" col-12 mb-0 mb-md-20 p-0">
                        <div class="d-none d-lg-block">
                            <h6 class=" float-left mb-0 fs-18 fw-700" style="color: #000000">International eSIM</h6>
                        </div>                    
                </div>
                <div class="col-12 p-0">
                    <div class="row p-0 m-0">
                        <div class="col-12 col-md-6 p-0 mt-20">
                            <div class="esim-img">
                                    <img src="assets/images/esim/eSim-banner.png" class="" >
                            </div>
                           <!-- <div class="esim-text">
                                    Load Your Student Pay Card with $3,000 or more to become eligible for an International eSIM.
                            </div>
                            <div class="esim-text1">
                                <label>
                                  <input type="checkbox" [(ngModel)]="isChecked" /> 
                                  I agree to the terms and conditions for claiming the free eSIM offer with WSFX, in partnership with Zetexa. I understand that I need to provide the required details for activation, and this offer is non-transferable and non-refundable. I also consent to my information being used for verification and activation
                                </label>
                            </div>-->
                              
                            <div class="col-md-6 col-12 mt-20 p-0 esim-button-box">
                                <button type="button" rippleEffect class="btn btn-esim1" (click)="goTobuyesim('BUY')" >Buy eSIM</button>
                                <button type="button"  class="btn btn-claim" (click)="goTobuyesim('CLAIM')">Claim eSIM</button>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">    
                            <div class="row features-section-box">
                                <div class="col-md-12">
                                    <ul ngbNav #nav="ngbNav" class="nav nav-pills nav-justified justify-content-center nav-fill mb-0">
                                        <li class="nav-item" ngbNavItem>
                                            <a ngbNavLink class="nav-link fs-12" href="#features" [ngClass]="{ 'active':activeTab==='features'}" data-toggle="tab" (click)="setActiveTab('features')">
                                                Features
                                            </a>
                                            <ng-template ngbNavContent>
                                                <section id="features" class="mt-6" style="width: 100%;">
                                                    <div class="row">
                                                        <div 
                                                            class="col-12 col-md-6"
                                                            [ngClass]="{'center-divider': i % 2 === 0, 'no-border-right': i % 2 !== 0}" 
                                                            *ngFor="let singleItem of menuItems; let i = index">
                                                            <div class="d-flex align-items-center justify-content-start single-features">
                                                                <img src="assets/images/esim/{{singleItem.icon}}" class="rounded-border">
                                                                <div class="fs-11 features-title fw-600">
                                                                    {{ singleItem.title }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </ng-template>
                                            
                                        </li>
                                        <li class="nav-item" ngbNavItem>
                                            <a ngbNavLink class="fs-12" href="#specifications" [ngClass]="{ 'active':activeTab==='specifications'}" data-toggle="tab" (click)="setActiveTab('specifications')">
                                                Specifications
                                            </a>
                                            <ng-template ngbNavContent>
                                                <section id="specifications mt-6" style="width: 100%;">
                                                    <div class="row">
                                                        <div class="col-12 col-sm-8 col-md-6"
                                                        [ngClass]="{'center-divider': i % 2 === 0, 'no-border-right': i % 2 !== 0}" 
                                                         *ngFor="let singleItem of esimItems; let i = index">
                                                            <div class="d-flex align-items-center justify-content-start single-features">
                                                                <img src="assets/images/esim/{{singleItem.icon}}" class="rounded-border">
                                                                <div class="fs-11">
                                                                    <span class="features-title fw-600">{{ singleItem.title }}</span> : <span class="feature-text">{{ singleItem.text }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </ng-template>
                                        </li>
                                    </ul>
                                    <div [ngbNavOutlet]="nav" class="card p-20"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="col-12 text-left ">
                </div> -->
                    
                     

                </div>
            </div>
        </div>
    </div>
</div>
                   
                